module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "headsOfLossForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "past_loss_of_services",
      "label": "Past Cost of Services",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfServices),
      expression: "pastCostOfServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "past_loss_of_services",
      "name": "past_loss_of_services",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfServices)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfServices = _vm.pastCostOfServices || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfServices = _vm.pastCostOfServices || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfServices = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_cost_of_travel",
      "label": "Past Cost of Travel",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "past_cost_of_travel",
      "name": "past_cost_of_travel",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "miscellaneous_costs",
      "label": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "miscellaneous_costs",
      "name": "miscellaneous_costs",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "focus": function($event) {
        _vm.misc = _vm.misc || ''
      },
      "blur": [function($event) {
        _vm.misc = _vm.misc || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss.length), function(index) {
    return _c('div', [_c('head-of-loss', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20",
    on: {
      "click": _vm.addCustomHeadOfLoss
    }
  }, [_vm._v("\n                    Add Another Head of Loss\n                ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Past Cost of Care",
      "tip-text": "You have two options to assess the past cost of care claim.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "care"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.careCalcType),
      expression: "careCalcType"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "careCalcType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.careCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateValid]
    }
  }, [_c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])]), _vm._v(" "), (_vm.careCalcType === 'own') ? _c('control', {
    attrs: {
      "for": "pastCostOfCare",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pastCostOfCare.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "pastCostOfCare",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "pastCostOfCare",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfCare = _vm.pastCostOfCare || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfCare = _vm.pastCostOfCare || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pastCostOfCare')
    }
  }, [_vm._v("\n                        Your own care figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.periods.length), function(index) {
    return (_vm.careCalcType === 'manual') ? _c('div', [_c('period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.periods.length >= 0 && _vm.careCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "care_total",
      "label": "Care Total",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.pastCostOfCare, '')
    }
  })])], 2)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12fcf54e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/OtherPastLosses.vue
// module id = 1575
// module chunks = 0